import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const SidebarContext = createContext();

export const useSidebar = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error('useSidebar must be used within a SidebarProvider');
    }
    return context;
};

export const SidebarProvider = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    /** True on routes whose layout renders no sidebar (e.g. account settings). */
    const [isSidebarHidden, setIsSidebarHidden] = useState(false);
    /** Where the header's back control returns to while the sidebar is hidden. */
    const [layoutBackTo, setLayoutBackTo] = useState('');
    const sidebarRef = useRef(null);

    // Handle outside clicks to close the sidebar
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                window.innerWidth < 1240 &&
                sidebarRef.current &&
                !sidebarRef.current.contains(event.target) &&
                !event.target.classList.contains('header')
            ) {
                setIsSidebarOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleSidebar = (value) => {
        setIsSidebarOpen(value);
    };

    const value = {
        isSidebarOpen,
        setIsSidebarOpen,
        isSidebarHidden,
        setIsSidebarHidden,
        layoutBackTo,
        setLayoutBackTo,
        toggleSidebar,
        sidebarRef,
    };

    return (
        <SidebarContext.Provider value={value}>
            {children}
        </SidebarContext.Provider>
    );
};

SidebarProvider.propTypes = {
    children: PropTypes.node,
};


